import $ from 'jquery';
import {showFormResponse} from "../common/json-response";

function deleteCustomColumnVariantHandler(e) {
  e.preventDefault();
  const button = e.currentTarget;
  const fieldUuid   = button.getAttribute('data-custom-field-uuid');
  const fieldFormat = button.getAttribute('data-custom-field-format');
  const variantUuid   = button.getAttribute('data-custom-column-variant-uuid');
  const fieldUuidAttr = '[data-custom-field-uuid="' + fieldUuid + '"]';
  const fieldFormatAttr = '[data-custom-field-format="' + fieldFormat + '"]';
  const url = button.getAttribute('data-delete-url');

  const data = {
    fieldUuid,
    fieldFormat,
    variantUuid
  };

  const statusWrapper = document.querySelector('.action-status-messages');

  $.ajax({
    type: "POST",
    url: url,
    dataType: 'json',
    data: data,
    success: function (data) {
      if (data.redirectTo?.length) {
        window.location.href = data.redirectTo;
      }

      showFormResponse(data);

      if (data.status !== 'success') {
        return;
      }

      const variantSelector = '.custom_field_params[data-custom-field-uuid="' + fieldUuid + '"] input[data-custom-column-variant-uuid="' + variantUuid + '"]';
      const customColumnVariant = document.querySelector(variantSelector);
      customColumnVariant.closest('.custom-columns-variant').remove();
    },
    error: function (data) {
      if (data.messages) {
        showFormResponse(data);
      } else {
        const message = 'Возникла ошибка. Обратитесь пожалуйста в тех. поддержку';
        const statusMsg = document.createElement('div');
        statusMsg.classList.add(['alert']);
        statusMsg.classList.add(['alert_error']);
        statusMsg.innerHTML = message;
        statusWrapper.appendChild(statusMsg);
      }
    },
  });
};

function initDeleteCustomColumnVariants() {
  const deleteButtons = document.querySelectorAll('.delete_custom_column_variant');

  deleteButtons?.forEach(function (button) {
    button.addEventListener('click', deleteCustomColumnVariantHandler);
  });
}

export {deleteCustomColumnVariantHandler, initDeleteCustomColumnVariants}